import axiosApi from './axiosApi';
import {ENCRYPT, DECRYPT} from './routes/security_routes';

export const encrypt = (data) => {
    return axiosApi.post(ENCRYPT, data);
};

export const decrypt = async (data) => {
    if (data === undefined || data === null) {
        return data;
    }

    if (typeof data === 'object' && data.error instanceof Error) {
        return data;
    }

    // If data is a string, wrap it in an array (backend expects array format)
    let payloadToSend = data;
    if (typeof data === 'string') {
        payloadToSend = [data];
    }

    try {
        if (Array.isArray(payloadToSend) && payloadToSend[0] && typeof payloadToSend[0] === 'string') {
            // If string is too large (> 10KB), backend will fail with 400
            // Just return it wrapped - the calling code will try to parse it as JSON
            if (payloadToSend[0].length > 10000) {
                return {data: payloadToSend[0]};
            }
        }
        
        // Try multiple formats to find what backend expects
        // Format 1: Raw string (like postTask)
        // Format 2: Array format [string]
        // Format 3: Object format {data: string}
        let response;
        if (Array.isArray(payloadToSend) && payloadToSend.length === 1 && typeof payloadToSend[0] === 'string') {
            const stringToSend = payloadToSend[0];
            
            // Try Format 1: Raw string with text/plain
            
            try {
                response = await axiosApi.post(DECRYPT, stringToSend, {
                    headers: {
                        'Content-Type': 'text/plain',
                    },
                    transformRequest: [(data) => {
                        return data;
                    }],
                    timeout: 60000,
                });
} catch (format1Error) {
                // Try Format 2: Array format [string]
                try {
                    response = await axiosApi.post(DECRYPT, payloadToSend, {
                        timeout: 60000,
                    });
} catch (format2Error) {
                    // Try Format 3: Object format {data: string}
                    try {
                        response = await axiosApi.post(DECRYPT, {data: stringToSend}, {
                            timeout: 60000,
                        });
} catch (format3Error) {
                        throw format3Error; // Throw the last error
                    }
                }
            }
        } else {
            response = await axiosApi.post(DECRYPT, payloadToSend, {
                timeout: 60000,
            });
        }
        const result = response?.data?.data ?? response?.data ?? response;
        
        if (typeof result === 'object' && result !== null) {
        }
        return result;
    } catch (error) {
        // If decryption fails with 400, the data might already be decrypted or in wrong format
        // Return the original data wrapped in expected format
        if (error?.response?.status === 400) {
            if (typeof data === 'object' && data !== null) {
                if (Array.isArray(data.data)) {
                    return {data: data.data};
                }
                if (data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
                    return {data: data.data};
                }
                return {data};
            }
            // If it's a string that failed to decrypt, return it wrapped
            return {data: data};
        }
        throw error;
    }
};